export default __webpack_public_path__ + "images/phone-agent.1ee7bac4.svg";